import React from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {
    mobileMediaQuery,
    notWebMediaQuery,
    webMediaQuery,
} from '../../../styles';
import GoChapterButton from '../GoChapterButton';

const ChapterSpoilerView = ({opened, correct, onDismiss, openChapter}) => {
    const {t} = useTranslation();
    const height = window.innerHeight;

    const onPress = () => {
        onDismiss();
    };

    return (
        <Background>
            <Container height={height}>
                <TopImage
                    src={require('../../../assets/ill_spoiler_bar.png')}
                    resizeMode="cover"
                />
                <Spacer ratio={0.4} />
                <Title>{t('comics.spoiler.title')}</Title>
                <Spacer />
                <CenterImage
                    src={require('../../../assets/ic_spoiler_warning.png')}
                />
                <Spacer />
                <Subtitle>
                    {t('comics.spoiler.description').replace(
                        '{chapter}',
                        correct.number.toString(),
                    )}
                </Subtitle>
                <Spacer />
                <StyledGotoButton chapter={correct} onPress={onPress} replace />
                <Spacer ratio={0.5} />
                <ContinueButton onClick={onDismiss}>
                    <ContinueText>
                        {t('comics.spoiler.continue').replace(
                            '{chapter}',
                            opened.number.toString(),
                        )}
                    </ContinueText>
                    <Line />
                </ContinueButton>
                <Spacer ratio={0.5} />
            </Container>
        </Background>
    );
};

const Background = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 5;

    ${notWebMediaQuery} {
        justify-content: flex-end;
    }
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 688px;
    height: 644px;
    max-height: ${props => props.height - 220}px;
    background-color: white;
    align-self: center;
    overflow: hidden;
    border-radius: 34px;
    align-items: center;

    ${notWebMediaQuery} {
        max-width: 90%;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
        justify-content: space-between;
    }
    ${webMediaQuery} {
        position: absolute;
        top: 220px;
        max-height: calc(97% - 220px);
    }
`;

const TopImage = styled.img`
    width: 100%;
`;

const Title = styled.span`
    font-family: TTNormsProExtraBlack;
    color: black;
    font-size: 32px;

    ${mobileMediaQuery} {
        font-size: 18px;
    }
`;

const Subtitle = styled.span`
    font-family: AvenirNextRoundedStd;
    font-weight: 400;
    font-size: 20px;
    color: black;

    max-width: 250px;
    text-align: center;
    ${mobileMediaQuery} {
        font-size: 16px;
    }
`;

const ContinueText = styled.span`
    font-family: AvenirNextRoundedStd;
    font-size: 16px;
    font-weight: 700;
    color: black;
    ${mobileMediaQuery} {
        font-size: 14px;
    }
`;

const CenterImage = styled.img`
    resize-mode: center;
`;

const StyledGotoButton = styled(GoChapterButton)`
    flex-shrink: 0;

    ${mobileMediaQuery} {
        margin-bottom: 0px;
        margin-top: 0px;
    }
`;

const Spacer = styled.span`
    flex: ${props => (props.ratio ? props.ratio : 1)};
`;

const ContinueButton = styled.span`
    display: flex;
    flex-direction: column;
    cursor: pointer;
    ${notWebMediaQuery} {
        margin-bottom: 40px;
        margin-top: 10px;
    }
`;

const Line = styled.span`
    width: 100%;
    height: 2px;
    margin-top: 6px;
    background: linear-gradient(
        90deg,
        #00aeef 0%,
        #ffd93f 32.81%,
        #ffd93f 68.75%,
        #ec008c 100%
    );
`;

export default ChapterSpoilerView;
